import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20minimalist%20digital%20security%20concept%20with%20a%20shield%20icon%20floating%20over%20a%20clean%20abstract%20background%2C%20soft%20gradients%20of%20warm%20amber%20and%20teal%20tones%2C%20subtle%20geometric%20patterns%2C%20modern%20cybersecurity%20illustration%20style%2C%20no%20text%2C%20smooth%20color%20transitions&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="应用安全背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-accent-500/90 text-white px-4 py-1.5 rounded-full text-xs md:text-sm font-medium mb-6">
          <i className="ri-alert-fill"></i>
          <span>安全警示：请勿下载来源不明的破解软件</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
          91破解版
          <span className="block text-xl md:text-2xl lg:text-3xl font-normal text-white/80 mt-2">
            官方最新版本免费下载 — 真相与风险
          </span>
        </h1>

        <p className="text-white/75 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          想找91破解版？在您下载之前，请花几分钟了解91破解版的真实情况、潜在的安全风险
          以及比破解版更安全、更可靠的合法替代方案。保护您的设备与数据安全，从正确的选择开始。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/security-risks"
            className="w-full sm:w-auto bg-accent-500 hover:bg-accent-600 text-white px-8 py-3 rounded-lg font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shield-flash-line mr-2"></i>
            了解安全风险
          </Link>
          <Link
            to="/category/alternatives"
            className="w-full sm:w-auto bg-white/15 hover:bg-white/25 text-white border border-white/30 px-8 py-3 rounded-lg font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-check-double-line mr-2"></i>
            查看正版替代方案
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10 text-white/50 text-xs">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line"></i>
            <span>安全科普</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-file-text-line"></i>
            <span>客观分析</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-lightbulb-line"></i>
            <span>实用建议</span>
          </div>
        </div>
      </div>
    </section>
  );
}